import React, { useEffect, useRef, useState } from 'react'
import { getOnlineRegistration } from '../Service/Api';
import { Link } from 'react-router-dom'
const Highlights = () => {
  const marqueeRef = useRef(null);
  const handleMouseOver = () => {
    marqueeRef.current.stop();
  };
  const handleMouseOut = () => {
    marqueeRef.current.start();
  };
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const data = await getOnlineRegistration(); 
      setData(data);
    };
    getData();
  }, []);


  const emptyArray = [
    { description: "Stay tuned for latest updates" }
  ];

  return (
    <>
      <div className="highlights">
        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/announce.gif" alt="Carmal convent school, Daruhera" className='announ-gif' />
        <marquee onMouseOver={(event) => event.currentTarget.stop()} onMouseOut={(event) => event.currentTarget.start()}>
            <p><Link to={data[0]?.url} target="_blank" className="parantlogo ">  {data[0]?.title}  </Link>
            {data[0]?.attachments && data[0]?.attachments.length > 0 && ( <Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0]?.attachments[0]}`} target="_blank" className=""> <i className="bi bi-paperclip"></i></Link>)}</p>
        </marquee>
      </div>
    </>
  )
}

export default Highlights
